export default __webpack_public_path__ + "media/images/about_us/roles/simone-surdi-e4141f4472c52abcd50afc5312ea144f.png";